var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SGPModalComponent',{attrs:{"tamanho":"xg","titulo":"Detalhes","mostrarFooter":false},on:{"sgpModalFechar":_vm.fecharModal}},[_c('DetalheTarefasComponent',{attrs:{"filtrosTarefas":_vm.filtrosTarefas}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }